<template>
    <div class="services">
        <!-- 页面标题 -->
        <div class="page-header">
            <h1>我们的服务</h1>
            <p>为企业提供全方位的软件开发解决方案</p>
        </div>

        <!-- 服务列表 -->
        <div class="section service-list">
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :md="8" v-for="service in services" :key="service.id">
                    <el-card class="service-card" :body-style="{ padding: '0px' }">
                        <div class="service-icon">
                            <el-icon :size="50"><component :is="service.icon" /></el-icon>
                        </div>
                        <div class="service-content">
                            <h3>{{ service.title }}</h3>
                            <p class="service-description">{{ service.description }}</p>
                            <div class="service-features">
                                <ul>
                                    <li v-for="(feature, index) in service.features" :key="index">
                                        <el-icon><Check /></el-icon>
                                        {{ feature }}
                                    </li>
                                </ul>
                            </div>
                            <el-button type="primary" @click="showServiceDetail(service)">了解详情</el-button>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>

        <!-- 服务详情对话框 -->
        <el-dialog
            v-model="dialogVisible"
            :title="selectedService?.title"
            width="70%"
            class="service-dialog"
        >
            <div v-if="selectedService" class="service-detail">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div class="detail-image">
                            <el-icon :size="100"><component :is="selectedService.icon" /></el-icon>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="detail-content">
                            <h3>服务介绍</h3>
                            <p>{{ selectedService.description }}</p>
                            <h3>核心功能</h3>
                            <ul>
                                <li v-for="(feature, index) in selectedService.features" :key="index">
                                    {{ feature }}
                                </li>
                            </ul>
                            <h3>技术优势</h3>
                            <p>{{ selectedService.advantages }}</p>
                            <div class="contact-section">
                                <h3>联系我们</h3>
                                <p>如果您对我们的服务感兴趣，请随时联系我们获取更多信息</p>
                                <el-button type="primary" size="large">立即咨询</el-button>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { ChatDotRound, Monitor, Cellphone, Check } from '@element-plus/icons-vue'

export default {
    name: 'Services',
    components: {
        ChatDotRound,
        Monitor,
        Cellphone,
        Check
    },
    data() {
        return {
            dialogVisible: false,
            selectedService: null,
            services: [
                {
                    id: 1,
                    icon: 'ChatDotRound',
                    title: '小程序开发',
                    description: '微信、支付宝、抖音等多平台小程序开发，助力企业快速布局移动端市场',
                    features: [
                        '多平台小程序开发',
                        '商城类小程序',
                        '社交类小程序',
                        '工具类小程序',
                        '企业展示小程序'
                    ],
                    advantages: '采用最新的小程序开发技术，确保应用性能优异，用户体验流畅。支持多平台发布，一次开发多端使用，降低开发成本。'
                },
                {
                    id: 2,
                    icon: 'Monitor',
                    title: '网站开发',
                    description: '响应式网站开发，企业官网、电商网站、管理系统等各类型网站定制',
                    features: [
                        '企业官网开发',
                        '电商网站开发',
                        '管理系统开发',
                        '响应式设计',
                        'SEO优化'
                    ],
                    advantages: '采用现代化的前端框架，确保网站性能优异，支持响应式设计，完美适配各种设备。注重用户体验和SEO优化，提升网站转化率。'
                },
                {
                    id: 3,
                    icon: 'Cellphone',
                    title: 'APP开发',
                    description: 'iOS与Android原生应用开发，跨平台应用开发，提供完整的移动应用解决方案',
                    features: [
                        'iOS原生开发',
                        'Android原生开发',
                        '跨平台开发',
                        'APP维护升级',
                        '性能优化'
                    ],
                    advantages: '拥有丰富的原生应用开发经验，确保应用性能优异，用户体验流畅。支持跨平台开发，降低开发成本，加快上线速度。'
                }
            ]
        }
    },
    methods: {
        showServiceDetail(service) {
            this.selectedService = service;
            this.dialogVisible = true;
        }
    }
}
</script>

<style scoped>
.services {
    padding: 80px 20px 40px;
}

.page-header {
    text-align: center;
    margin-bottom: 40px;
}

.page-header h1 {
    font-size: 36px;
    color: #2c3e50;
    margin-bottom: 10px;
}

.page-header p {
    font-size: 18px;
    color: #666;
}

.section {
    margin-bottom: 40px;
}

.service-card {
    height: 100%;
    margin-bottom: 30px;
    transition: all 0.3s ease;
}

.service-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.service-icon {
    padding: 30px 0;
    text-align: center;
    color: #409EFF;
    background-color: #f5f7fa;
}

.service-content {
    padding: 20px;
    text-align: center;
}

.service-content h3 {
    margin: 0 0 15px;
    font-size: 24px;
    color: #2c3e50;
}

.service-description {
    color: #666;
    margin-bottom: 20px;
    line-height: 1.6;
}

.service-features {
    margin: 20px 0;
    text-align: left;
}

.service-features ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.service-features li {
    margin: 10px 0;
    color: #666;
    display: flex;
    align-items: center;
}

.service-features .el-icon {
    color: #67C23A;
    margin-right: 10px;
}

/* 服务详情对话框样式 */
.service-detail {
    padding: 20px;
}

.detail-image {
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f7fa;
    border-radius: 8px;
    color: #409EFF;
}

.detail-content {
    padding: 20px;
}

.detail-content h3 {
    color: #2c3e50;
    margin: 20px 0 10px;
}

.detail-content p {
    color: #666;
    line-height: 1.6;
    margin-bottom: 20px;
}

.detail-content ul {
    padding-left: 20px;
    color: #666;
    margin-bottom: 20px;
}

.detail-content li {
    margin-bottom: 8px;
}

.contact-section {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #eee;
    text-align: center;
}

/* 响应式布局 */
@media (max-width: 768px) {
    .services {
        padding: 60px 10px 20px;
    }

    .page-header h1 {
        font-size: 28px;
    }

    .page-header p {
        font-size: 16px;
        padding: 0 15px;
    }

    .service-card {
        margin-bottom: 20px;
    }

    .service-icon {
        padding: 20px 0;
    }

    .service-content {
        padding: 15px;
    }

    .service-content h3 {
        font-size: 20px;
        margin-bottom: 10px;
    }

    .service-description {
        font-size: 14px;
        margin-bottom: 15px;
    }

    .service-features li {
        font-size: 14px;
        margin: 8px 0;
    }

    .detail-image {
        height: 250px;
        margin-bottom: 20px;
    }

    .detail-content {
        padding: 15px 0;
    }

    .detail-content h3 {
        font-size: 18px;
        margin: 15px 0 8px;
    }

    .detail-content p {
        font-size: 14px;
        margin-bottom: 15px;
    }

    .detail-content ul {
        padding-left: 15px;
        margin-bottom: 15px;
    }

    .detail-content li {
        font-size: 14px;
        margin-bottom: 6px;
    }

    .contact-section {
        margin-top: 20px;
        padding-top: 15px;
    }

    .contact-section h3 {
        font-size: 18px;
    }

    .contact-section p {
        font-size: 14px;
    }

    /* 调整对话框在移动端的宽度 */
    :deep(.el-dialog) {
        width: 90% !important;
        margin: 0 auto;
    }

    /* 调整按钮在移动端的大小 */
    :deep(.el-button) {
        padding: 8px 15px;
        font-size: 14px;
    }

    /* 调整图标在移动端的大小 */
    :deep(.el-icon) {
        font-size: 20px;
    }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
    .services {
        padding: 50px 10px 15px;
    }

    .page-header h1 {
        font-size: 24px;
    }

    .page-header p {
        font-size: 14px;
    }

    .service-content h3 {
        font-size: 18px;
    }

    .service-description {
        font-size: 13px;
    }

    .service-features li {
        font-size: 13px;
    }

    .detail-image {
        height: 200px;
    }

    :deep(.el-dialog) {
        width: 95% !important;
    }
}
</style>
